module.exports = __webpack_public_path__ + "img/userAvatar.4a048c5a.svg";